import React, { useState } from 'react';
import Stack from '@mui/material/Stack/Stack';
import Typography from '@mui/material/Typography/Typography';
import TextField from '@mui/material/TextField/TextField';
import Button from '@mui/material/Button/Button';
import Alert from '@mui/material/Alert/Alert';
import Card from '@mui/material/Card/Card';
import CardContent from '@mui/material/CardContent/CardContent';
import { PageContainer } from '../../components/PageContainer';
import { createMyOrganization } from '../../services/organization.service';

/**
 * Self-serve company set-up: a name is enough. The person becomes its admin and lands on its settings (branding,
 * other admins); their next hackathons pick it up on the create form.
 */
export const NewOrganization = () => {
    const [name, setName] = useState('');
    const [error, setError] = useState('');
    const [saving, setSaving] = useState(false);

    const create = () => {
        if (!name.trim()) {
            setError('Give your company a name');
            return;
        }
        setSaving(true);
        setError('');
        createMyOrganization(name.trim()).then(org => {
            // a full load, so the account menu and the create form see the new company
            window.location.assign(`/org/${org.slug}`);
        }, err => {
            setError(err.response?.data?.message || 'Could not set up the company');
            setSaving(false);
        });
    };

    return (
        <PageContainer>
            <Stack spacing={3} sx={{ maxWidth: 640 }}>
                <Typography variant="h1" sx={{ fontSize: { xs: '1.75rem', md: '2.25rem' } }}>Set up your company</Typography>
                <Card>
                    <CardContent>
                        <Stack spacing={2} component="form" onSubmit={(e: React.FormEvent) => { e.preventDefault(); create(); }}>
                            <Typography color="text.secondary">
                                One place for your company's look and the people who run your hackathons. Set the logo and colours once,
                                and every hackathon you link to the company uses them.
                            </Typography>
                            <TextField label="Company name" value={name} autoFocus
                                error={!!error && !name.trim()} helperText={!!error && !name.trim() ? error : undefined}
                                onChange={e => { setName(e.target.value); setError(''); }} />
                            {error && name.trim() && <Alert severity="error">{error}</Alert>}
                            <Stack direction="row">
                                <Button type="submit" variant="contained" disabled={saving}>{saving ? 'Setting up…' : 'Set up company'}</Button>
                            </Stack>
                            <Typography variant="body2" color="text.secondary">
                                You'll be its admin and can add other admins. Branding shows on Pro events (see Pricing).
                            </Typography>
                        </Stack>
                    </CardContent>
                </Card>
            </Stack>
        </PageContainer>
    );
}
